"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultPurposeSubCategoryType = void 0;
const type_utils_1 = require("@transcend-io/type-utils");
const additional_1 = require("./additional");
const advertising_1 = require("./advertising");
const analytics_1 = require("./analytics");
const essential_1 = require("./essential");
const hr_1 = require("./hr");
const legal_1 = require("./legal");
const marketing_1 = require("./marketing");
const operationSecurity_1 = require("./operationSecurity");
const other_1 = require("./other");
const personalization_1 = require("./personalization");
const sale_1 = require("./sale");
const transfer_1 = require("./transfer");
exports.DefaultPurposeSubCategoryType = (0, type_utils_1.makeEnum)({
    ...additional_1.AdditionalPurposeSubCategory,
    ...advertising_1.AdvertisingPurposeSubCategory,
    ...analytics_1.AnalyticsPurposeSubCategory,
    ...essential_1.EssentialPurposeSubCategory,
    ...hr_1.HRPurposeSubCategory,
    ...legal_1.LegalPurposeSubCategory,
    ...marketing_1.MarketingPurposeSubCategory,
    ...operationSecurity_1.OperationSecurityPurposeSubCategory,
    ...other_1.OtherPurposeSubCategory,
    ...personalization_1.PersonalizationPurposeSubCategory,
    ...sale_1.SalePurposeSubCategory,
    ...transfer_1.TransferPurposeSubCategory,
});
//# sourceMappingURL=index.js.map